import { ArrowUpRight, X } from "lucide-react";
import { Button } from "@/components/ui/Button";
import { isInsufficientCreditError } from "../lib/app-errors";
import { normalizeInstallUrl } from "../lib/app-mode";

export function isCreditError(error: unknown): boolean {
  return isInsufficientCreditError(error);
}

export function CreditDrawer({ onClose }: { onClose: () => void }) {
  const destination = normalizeInstallUrl(import.meta.env.VITE_SAPPS_BILLING_URL) ?? undefined;
  return (
    <>
      <div className="fixed inset-0 z-[60] bg-black/50" onClick={onClose} aria-hidden="true" />
      <div className="fixed inset-x-0 bottom-0 z-[61] p-4 pb-[env(safe-area-inset-bottom)]">
        <div className="mx-auto flex w-full max-w-xl flex-col gap-4 rounded-2xl border border-border bg-surface p-5 shadow-xl" role="dialog" aria-modal="true" aria-labelledby="credit-drawer-title" data-testid="credit-drawer">
          <div className="flex items-start justify-between gap-3">
            <div>
              <p className="text-xs font-semibold uppercase tracking-[0.16em] text-warning">AI access paused</p>
              <h2 id="credit-drawer-title" className="mt-1 text-lg font-semibold text-text">Add credits to keep using BiteTrack AI</h2>
            </div>
            <button type="button" aria-label="Close credit notice" onClick={onClose} className="flex h-11 w-11 items-center justify-center rounded-full text-text-muted active:bg-muted select-none"><X size={18} /></button>
          </div>
          <p className="text-sm leading-relaxed text-text-muted">Your Sapps account does not currently have enough AI credits or an active subscription. Top up in the Sapps app, then return here to continue chatting.</p>
          {destination ? (
            <Button
              data-testid="credit-top-up-btn"
              onClick={() => window.open(destination, "_blank", "noopener,noreferrer")}
            >
              Open Sapps billing <ArrowUpRight size={17} />
            </Button>
          ) : (
            <div className="rounded-xl border border-border bg-muted px-4 py-3" role="status" data-testid="credit-billing-unavailable">
              <p className="text-sm font-medium text-text">Billing link unavailable</p>
              <p className="mt-1 text-xs leading-relaxed text-text-muted">Open Sapps billing from the main app to add credits, then return here.</p>
            </div>
          )}
        </div>
      </div>
    </>
  );
}
